import React from 'react'
import { Box } from '@node-space/ui-components'
import { MassPayoutFileUpload } from '../components/FileUpload/MassPayoutFileUpload'
import MassPayoutModal from '../components/MassPayoutModal'
import { MassPayoutSubmitButton } from '../components/MassPayoutSubmitButton'
import { MassPayoutTypeSelection } from '../components/MassPayoutTypeSelection'
import { MassPayoutWalletSelection } from '../components/MassPayoutWalletSelection'

export const MassPayoutsUploadForm = () => {
  return (
    <Box flexCol width="full">
      <Box flexCol className="justify-center items-center gap-y-6 w-full">
        <Box flexCol className="gap-y-6 w-100">
          <MassPayoutTypeSelection />
          <MassPayoutWalletSelection />
          <MassPayoutFileUpload />
          <MassPayoutSubmitButton />
          <MassPayoutModal />
        </Box>
      </Box>
    </Box>
  )
}
